 
import { call, select, takeLatest } from 'redux-saga/effects';
import { actions } from './breadcrumbs.slice';

import { ItemType } from 'antd/lib/breadcrumb/Breadcrumb';
import {
  BreadcrumbId,
  MakeBreadcrumbsAction,
  ShortBreadcrumb,
} from './breadcrumbs.types';

import { routesPath } from 'src/router/routes';
import { menuConfig } from 'src/constants/menu';
import { AuthUser } from '@dynamika-shared/types/auth';
import { selectAuthState } from '../auth/auth.slice';
import { dispatch, logError } from '../helpers';

export function calculateBreadcrumbs(userData?: AuthUser) {
  const currentPath = window.location.pathname;
  const menuRoutes = !userData?.selectedRole
    ? []
    : menuConfig[userData.selectedRole]
        .map(item => [item, ...(item.children || [])])
        .flat();

  const sections = currentPath.split('/').filter(Boolean) || ['dashboard'];

  return sections.reduce<ItemType[]>((acc, _section, index) => {
    const path = `/${sections.slice(0, index + 1).join('/')}`;
    const route = menuRoutes.find(item => item.path === path);
    if (route) {
      acc.push({
        title: route.title,
        path: index == sections.length - 1 ? undefined : path,
      });
    }
    return acc;
  }, []);
}

export const replacer =
  (ids: BreadcrumbId[]) => (str: string, m: string, i: number) =>
    ids.length > 0 ? str.replace(m, (ids[i] ?? '') + '') : str;

export const createBreadcrumbs = (
  crumbs: ShortBreadcrumb[],
  ids: BreadcrumbId[]
) =>
  crumbs.map(([title, pathKey]) => {
    const url = routesPath[pathKey];
    if (!url) {
      console.error('Invalid path key', pathKey);

      return { title, path: '' };
    }
    const replacedPath = url.match(/(:\w+)/g)?.reduce(replacer(ids), url);

    return {
      title: title ?? '',
      path: replacedPath ?? url,
    };
  });

export function* makeBreadcrumbsWorker({
  payload: { crumbs, ids },
}: MakeBreadcrumbsAction) {
  try {
    const breadcrumbs: ReturnType<typeof createBreadcrumbs> = yield call(
      createBreadcrumbs,
      crumbs,
      ids || []
    );
    yield dispatch(actions.setBreadcrumbs(breadcrumbs));
  } catch (error) {
    yield call(logError, error);
  }
}

export function* resetBreadcrumbsWorker() {
  try {
    const authState: ReturnType<typeof selectAuthState> =
      yield select(selectAuthState);

    const breadcrumbs: ReturnType<typeof calculateBreadcrumbs> = yield call(
      calculateBreadcrumbs,
      authState?.data
    );
    yield dispatch(actions.setBreadcrumbs(breadcrumbs));
  } catch (error) {
    yield call(logError, error);
  }
}

export function* breadcrumbsSaga() {
  yield takeLatest(actions.makeBreadcrumbs.type, makeBreadcrumbsWorker);
  yield takeLatest(actions.resetBreadcrumbs.type, resetBreadcrumbsWorker);
}
